import {useState} from 'react'
import FarmerBalanceForm from './FarmerBalanceForm';
import FarmerBalanceList from './FarmerBalanceList';

const FarmerBalance = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <FarmerBalanceForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <FarmerBalanceList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default FarmerBalance